import { useDeleteDespesaGroupPay } from "hooks/groupPay/useDeleteDespesaGroupPay";
import CustomButton from "shared/components/button/CustomButton";
import CustomModal from "shared/components/modal/CustomModal";
import {
  formatarCpfOuCnpjEmissorParaExibicao,
  rotuloCpfOuCnpj,
} from "shared/util/formatters/cnpj";

interface ModalExcluirDespesaGroupPayProps {
  cpfCnpjEmissor: string;
  showModal: boolean;
  despesaId: number;
  onCloseModal: () => void;
  nomeFornecedor: string;
}

const ModalExcluirDespesaGroupPay: React.FC<ModalExcluirDespesaGroupPayProps> = ({
  cpfCnpjEmissor,
  showModal,
  despesaId,
  onCloseModal,
  nomeFornecedor,
}) => {
  const { mutateAsync: excluirDespesaAsync } = useDeleteDespesaGroupPay();

  const handleExcluirDespesa = async () => {
    await excluirDespesaAsync(despesaId);
    onCloseModal();
  };

  const getNomeFornecedor = () => {
    return nomeFornecedor && nomeFornecedor.trim() !== "" ? nomeFornecedor : "-";
  };

  const getCpfCnpjFormatado = () => {
    if (!cpfCnpjEmissor || cpfCnpjEmissor.trim() === "") return "CPF/CNPJ: -";
    const labelCpfCnpj = rotuloCpfOuCnpj(cpfCnpjEmissor);
    const docFormatado = formatarCpfOuCnpjEmissorParaExibicao(cpfCnpjEmissor);
    return `${labelCpfCnpj}: ${docFormatado || "-"}`;
  };

  const Content = () => {
    return (
      <div style={{ padding: "1.5rem", textAlign: "left" }}>
        <h2 style={{ fontSize: "1.25rem", fontWeight: "700", margin: 0 }}>
          Tem certeza que deseja excluir esta despesa?
        </h2>

        <p style={{ fontSize: "1rem", color: "#555", marginTop: "1rem" }}>
          Ao remover a despesa referente ao <b>{getNomeFornecedor()}</b>{", "}
          <b>{getCpfCnpjFormatado()}</b>, ela sairá da lista e, se
          necessário, será preciso lançá-la manualmente depois.
        </p>
      </div>
    )
  }

  const FooterContent = () => {
    return (
      <div style={{ display: "flex", justifyContent: "center", width: "100%", padding: "1rem 0", gap: "1rem" }}>
        <CustomButton
          id="cancelar-exluir-despesa-group-pay"
          label="Cancelar"
          onClick={onCloseModal}
          variant="danger-alt"
          size="lg"
          style={{ minWidth: "150px", padding: "0.5rem 1.5rem" }}
        />
        <CustomButton
          id="exluir-despesa-group-pay"
          label="Excluir despesa"
          onClick={handleExcluirDespesa}
          variant="primary"
          size="lg"
          style={{ minWidth: "150px", padding: "0.5rem 1.5rem" }}
        />
      </div>
    )
  }

  return (
    <CustomModal
      key="modal-excluir-despesa-group-pay"
      titulo="Excluir despesa"
      size="sm"
      tipoModal="MODAL_CENTRAL"
      fecharModalAoClicarFora
      scrollable
      customFooter={<FooterContent />}
      onCloseModal={onCloseModal}
      showModal={showModal}
    >
      <Content />
    </CustomModal>
  );
};

export default ModalExcluirDespesaGroupPay;